import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { RotateCcw, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";

// "Reset my assessment": removes placement-assessment effects; competency is rebuilt from missions only.
export default function ResetAssessment({ onDone }) {
  const navigate = useNavigate();
  const [status, setStatus] = useState(null);
  const [confirm, setConfirm] = useState(false);
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => { api.get("/competency/assess/status").then((r) => setStatus(r.data)).catch(() => {}); }, []);

  const reset = async () => {
    setBusy(true);
    try { await api.post("/competency/assess/reset"); setDone(true); setConfirm(false); toast.success("Assessment reset."); onDone && onDone(); }
    catch (e) { toast.error(apiErr(e)); } finally { setBusy(false); }
  };

  if (!status) return null;
  return (
    <div className="tc-card p-5" data-testid="reset-assessment-card">
      <div className="font-semibold flex items-center gap-2"><RotateCcw className="w-4 h-4 text-tc-mastery" /> Reset my assessment</div>
      <p className="text-sm text-tc-sub mt-1">Removes everything the placement assessment added. Your competency is rebuilt from your missions only. XP, mission stars and your streak are not touched.</p>
      {done ? (
        <div className="mt-3 flex flex-wrap gap-2" data-testid="reset-assessment-done">
          <button data-testid="reset-retake-btn" onClick={() => navigate("/assess")} className="rounded-lg bg-tc-mastery text-tc-bg font-semibold px-4 py-2 text-sm">Retake the assessment</button>
          <button data-testid="reset-beginner-btn" onClick={() => navigate("/training")} className="rounded-lg bg-white/5 border border-white/10 px-4 py-2 text-sm">Start as a beginner</button>
        </div>
      ) : confirm ? (
        <div className="mt-3 flex flex-wrap gap-2">
          <button data-testid="reset-assessment-confirm" disabled={busy} onClick={reset} className="rounded-lg bg-tc-bear/15 border border-tc-bear/40 text-tc-bear font-semibold px-4 py-2 text-sm flex items-center gap-2">{busy && <Loader2 className="w-4 h-4 animate-spin" />} Yes, reset it</button>
          <button data-testid="reset-assessment-cancel" onClick={() => setConfirm(false)} className="rounded-lg bg-white/5 border border-white/10 px-4 py-2 text-sm">Cancel</button>
        </div>
      ) : (
        <button data-testid="reset-assessment-btn" disabled={!status.assessed} onClick={() => setConfirm(true)}
          className="mt-3 rounded-lg bg-white/5 border border-white/10 px-4 py-2 text-sm hover:border-white/30 disabled:opacity-50">
          {status.assessed ? "Reset assessment" : "No assessment to reset"}
        </button>
      )}
    </div>
  );
}
